/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./js/main.js":
/*!********************!*\
  !*** ./js/main.js ***!
  \********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _modules_gwp_products__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/gwp-products */ \"./js/modules/gwp-products.js\");\n/* harmony import */ var _modules_gwp_products__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_gwp_products__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var _modules_video_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/video-modal */ \"./js/modules/video-modal.js\");\n/* harmony import */ var _modules_video_modal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_video_modal__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var _modules_sticky__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/sticky */ \"./js/modules/sticky.js\");\n/* harmony import */ var _modules_sticky__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_modules_sticky__WEBPACK_IMPORTED_MODULE_2__);\n\n\n\n$(function () {\n  _jQuery('.subscription-select').niceSelect();\n  $('.owl-dot').attr('aria-label', 'Carousel Pagination');\n  $('.owl-next').attr('aria-label', 'Carousel Next');\n  $('.owl-prev').attr('aria-label', 'Carousel Previous');\n  $('.outer-link > img').closest('.outer-link').addClass('active');\n  $('.h-terms-link a img').closest('a').addClass('active');\n});\n$('.outer-link > img').closest('.outer-link').addClass('active');\n$('.h-terms-link a img').closest('a').addClass('active');\n\n//# sourceURL=webpack://src/./js/main.js?");

/***/ }),

/***/ "./js/modules/gwp-products.js":
/*!************************************!*\
  !*** ./js/modules/gwp-products.js ***!
  \************************************/
/***/ (() => {

eval("\n\n//# sourceURL=webpack://src/./js/modules/gwp-products.js?");

/***/ }),

/***/ "./js/modules/sticky.js":
/*!******************************!*\
  !*** ./js/modules/sticky.js ***!
  \******************************/
/***/ (() => {

eval("ScrollTrigger.matchMedia({\n  \"(min-width: 992px)\": function minWidth992px() {\n    var navHeight = $('.navbar__main').height();\n    document.querySelectorAll('[data-sticky]').forEach(function (stickyEl) {\n      var stickyTarget = stickyEl.getAttribute('data-sticky');\n      var offset = stickyEl.getAttribute('data-offset');\n      var getOffset = function getOffset(offset) {\n        return offset ? -1 * offset : -navHeight;\n      };\n      var offsetBottom = stickyEl.getAttribute('data-offset-bottom');\n      offsetBottom = offsetBottom ? offsetBottom : 'bottom';\n      var ST = ScrollTrigger.create({\n        trigger: stickyTarget,\n        start: function start() {\n          return \"\".concat(getOffset(offset), \" top\");\n        },\n        end: function end() {\n          return \"bottom \".concat(offsetBottom);\n        },\n        pin: stickyEl,\n        scroller: '.smooth-scroll',\n        pinSpacing: false,\n        pinType: 'transform'\n      });\n    });\n    $(window).on('resize', function () {\n      navHeight = $('.navbar__main').height();\n    });\n  }\n});\n\n//# sourceURL=webpack://src/./js/modules/sticky.js?");

/***/ }),

/***/ "./js/modules/video-modal.js":
/*!***********************************!*\
  !*** ./js/modules/video-modal.js ***!
  \***********************************/
/***/ (() => {

eval(`
  function YouTubeGetID(url) {
    url = url.split(/(vi\\/|v=|\\/v\\/|youtu\\.be\\/|\\/embed\\/)/);
    return url[2] !== undefined ? url[2].split(/[^0-9a-z_\\-]/i)[0] : url[0];
  }

  document.querySelectorAll('[data-video]').forEach(function (el, index) {
    var video_url = el.getAttribute('data-video');
    var modalId = 'video-modal-' + index;
    var titleId = 'video-modal-title-' + index;

    var $modal = $(\`
      <div class="video-modal" id="\${modalId}" role="dialog" aria-modal="true" aria-labelledby="\${titleId}">
        <div class="modal__top-button">
          <div class="close-button modal__close-button" tabindex="0" role="button" aria-label="Close video modal"></div>
        </div>

        <div class="video-modal__inner">
          <h2 id="\${titleId}" class="visually-hidden">Video Player: Modal</h2>
          <div class="vimeo-div" style="padding:56.25% 0 0 0;position:relative;">
            <iframe 
              style="position:absolute;top:0;left:0;width:100%;height:100%;" 
              data-src="\${video_url}?autoplay=1" 
              title="Video player" 
              aria-label="Video player"
              frameborder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowfullscreen>
            </iframe>
          </div>        
        </div>
      </div>
    \`);

    $modal.appendTo('body');

    // Close on click
    $modal.on('click', '.modal__close-button', function () {
      var $modal = $(this).closest('.video-modal');
      $modal.removeClass('show-video');
      $modal.find('iframe').attr('src', '');
    });

    // Close on keydown (Enter or Space)
    $modal.find('.modal__close-button').on('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).click();
      }
    });

    // Close on Escape
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') {
        $('.video-modal.show-video').each(function () {
          $(this).removeClass('show-video').find('iframe').attr('src', '');
        });
      }
    });

    // Open modal
    $(el).on('click', function (e) {
      e.preventDefault();
      var $iframe = $modal.find('iframe');
      $modal.addClass('show-video');
      $iframe.attr('src', $iframe.attr('data-src'));
    });
  });
`);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./js/main.js");
/******/ 	
/******/ })()
;